<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 4.82617V9.82619H9.00002" stroke="#8D959D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M6.09167 13.9924C7.20168 17.143 10.2616 19.1798 13.5965 18.9879C16.9314 18.7959 19.7374 16.4216 20.4786 13.1644C21.2198 9.90725 19.7175 6.5525 16.7941 4.93638C13.8706 3.32026 10.2307 3.83237 7.86668 6.19241L4 9.82576" stroke="#8D959D" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
